import { useState } from 'react';
import { InView } from 'react-intersection-observer';
import { ingredientsData } from './data/ingredientsData.js';
import './scss/Ingredients.scss';

function Ingredients() {
  
  const [isCollapsed, setIsCollapsed] = useState(false);
  const [showFooter, setShowFooter] = useState(false);
  const [footerIsOpen, setFooterIsOpen] = useState(false);

  function toggleSection() {
    setIsCollapsed(!isCollapsed)
  }

  function showHideFooter(inView, entry) {
    setShowFooter(entry.boundingClientRect.top < 0 ? !inView : false)
  }

  function openCloseFooter() {
    setFooterIsOpen(!footerIsOpen)
  }

  function blockClick(e) {
    e.preventDefault()
    e.stopPropagation()
  }

  const ingredientsList = ingredientsData.map(list =>
    <ul id={list.id} key={list.id}>
      {list.name ? <p className="list-name">{list.name}</p> : null }
      {list.items.map(item => 
        <li key={item.name}>
        <input type="checkbox" id={item.name} />
        <label htmlFor={item.name}>
          <b>{item.name}</b> 
          { item.amount ? 
            <span className="amount">({item.amount})</span> 
          : null }
          { item.note ? 
            <span className="ingredient-note">{item.note}</span>
          : null }
        </label>
      </li>
      )}
    </ul>
  )

  return (
    <InView 
      as="section" 
      onChange={(inView, entry) => showHideFooter(inView, entry)} 
      id="ingredients"
      className="collapsible"
      data-collapsed={isCollapsed}
    >
      <h2 onClick={toggleSection} className="section-header">Ingredients</h2>
      <div className="ingredients-container section-content">
        {ingredientsList}
      </div>
      { showFooter ? 
        <footer className={footerIsOpen ? 'open' : 'closed'} onClick={openCloseFooter}>
          <div className="footer-container">  
            <header onClick={openCloseFooter}>
              <p>Ingredients list</p>
              <button className="icon small"></button>
            </header>
            <div 
              className="ingredients-container"
              onClick={blockClick}
            >{ingredientsList}</div>
          </div>
        </footer>
        : null 
      }
    </InView>
  );
}

export default Ingredients;
